
class GenerateRequestId {

  geneRateRequestId() {
    const d = Date.now();
    const val = Math.floor(1000 + Math.random() * 9000);
    console.log(d, ' ', val, ' ', `${d}${val}`)
    return `${d}${val}`;
  }
  Capitalize(str) {
   
    if (str===null || str === undefined) {
     
      return ''
    } else {
     
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }
}

export default new GenerateRequestId();